var colors = require('./colors');
module['exports'] = colors;

// Remark: By default, colors will add style properties to String.prototype
//
// If you don't wish to extend String.prototype you can do this instead and native String will not be touched
//
//   var colors = require('colors/safe);
//   colors.red("foo")
//
//
require('./extendStringPrototype')();


//////////////////
// WEBPACK FOOTER
// ./node_modules/colors/lib/index.js
// module id = 610
// module chunks = 0